<h2 mat-dialog-title>Loading File</h2>

<mat-dialog-content>

    <div class="loading">
        <img src="/img/loading_animation.gif">
        <div>
            <p>Loading Workspace<br>{{name}}</p>
        </div>
    </div>
</mat-dialog-content>